<template lang="pug">
  #app(ref="content")
    template(v-if="isPC")
      .pc: img(src="@/assets/images/common/image_pc.png")
    template(v-else)
      .landscape(v-if="isLandscapeScreen")
        p.image: img(src="@/assets/images/common/image_landscape.png")
      .sp(v-if="isSoundLoaded" :class="{ 'is-landscape': isLandscapeScreen }")
        router-view
</template>

<script>
import CookieData from '@/assets/js/CookieData';
import UA from '@/assets/js/UA';
import SoundController from '@/assets/js/SoundController';

export default {
  name: 'Home',
  data() {
    return {
      isLandscapeScreen: false,
      isSoundLoaded: false
    };
  },
  computed: {
    isPC() {
      // return false;
      return UA.isPC;
    }
  },
  watch: {
    $route() {
      this.$refs.content.scrollTop = 0;
    }
  },
  mounted() {
    // 「Close時にはhappyturn topへredirect」のカヤックテストサイト用仮対応
    // 本番向けは htaccess による redirect設定を行う
    window.location.href = 'https://www.happyturn.com/';
    // SoundController.load().then(() => {
    //   this.isSoundLoaded = true;
    //   SoundController.mute(CookieData.isMute);

    //   this.onResize();
    //   window.addEventListener('resize', this.onResize);
    //   window.addEventListener('orientationchange', this.onResize);

    //   this.jump();
    //});
  }
  // methods: {
  //   onResize() {
  //     const before = this.isLandscapeScreen;
  //     this.isLandscapeScreen = window.innerWidth > window.innerHeight;
  //     if (this.isLandscapeScreen != before) {
  //       SoundController.stopAll();
  //       this.jump();
  //     }
  //   },
  //   jump() {
  //     if (this.$router.currentRoute.name !== 'welcome') {
  //       this.$router.push({ name: 'welcome' });
  //     }
  //   }
  // }
};
</script>

<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
  .pc {
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .landscape {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('assets/images/common/bg_castle_landscape.png') no-repeat
      center;
    background-size: cover;
    z-index: 1;
    .image {
      width: 140vmin;
      max-width: 1303px;
    }
  }
  .sp {
    overflow-x: hidden;
    overflow-y: scroll;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    &.is-landscape {
      visibility: hidden;
      overflow-y: hidden;
    }
  }
}
</style>
